import { CollectionListResource, CollectionListResourceCollections } from "@/api/generated-api";

export const formattedCollections = (collections: CollectionListResource): CollectionListResourceCollections[] => {
  return collections.collections;
};
